export const REFRESH_PAYMENT_REQUIRED_CODE = `REFRESH_PAYMENT_REQUIRED`

export const REFRESH_PAYMENT_REQUIRED_MESSAGE = `Refresh Pricing to bring the payment up to date before applying for financing.`

export const BATTERY_CONCERT_AMOUNT_OUT_OF_RANGE_CODE = `BATTERY_CONCERT_AMOUNT_OUT_OF_RANGE`

export const errorBody = (error: unknown): Record<string, unknown> | null => {
  if (error == null || typeof error !== `object` || !(`response` in error)) {
    return null
  }

  const { response } = error
  if (
    response == null ||
    typeof response !== `object` ||
    !(`data` in response)
  ) {
    return null
  }

  const { data } = response
  return data != null && typeof data === `object`
    ? (data as Record<string, unknown>)
    : null
}

export const isRefreshPaymentRequiredError = (error: unknown): boolean =>
  errorBody(error)?.error === REFRESH_PAYMENT_REQUIRED_CODE

/**
 * The Battery price is outside the configured Concert Battery loan-amount
 * range. Its message names the bound that failed and the current price, so it
 * is worth showing verbatim rather than replacing with generic copy.
 */
export const isBatteryConcertAmountError = (error: unknown): boolean =>
  errorBody(error)?.error === BATTERY_CONCERT_AMOUNT_OUT_OF_RANGE_CODE

export const batteryConcertAmountErrorMessage = (
  error: unknown,
): string | null => {
  if (!isBatteryConcertAmountError(error)) {
    return null
  }
  const { message } = errorBody(error) ?? {}
  return typeof message === `string` && message.trim().length > 0
    ? message
    : null
}

/**
 * The server's corrective reason when one is present: `howToFix` first, then
 * `message`. Used for BrightStart validation and provider failures so the
 * seller sees the contract text rather than a generic drawer prompt.
 */
export const batteryApiErrorMessage = (error: unknown): string | null => {
  const body = errorBody(error)
  if (body == null) {
    return null
  }
  const { howToFix, message } = body
  if (typeof howToFix === `string` && howToFix.trim().length > 0) {
    return howToFix
  }
  if (typeof message === `string` && message.trim().length > 0) {
    return message
  }
  if (
    Array.isArray(message) &&
    message.length > 0 &&
    message.every((entry) => typeof entry === `string`)
  ) {
    return message.join(`, `)
  }
  return null
}
